import React from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';


const MyModal = ({ isOpenMyModal, onCloseMyModal, modalQuestion, onNoModalClick, onYesModalClick, onCancelMyModal }) => {


    return (
        <>
            <Modal isOpen={isOpenMyModal} onRequestClose={onCloseMyModal}>
                    <button onClick={onCancelMyModal} className='float-right'>
                        <FontAwesomeIcon icon={faXmark} color='#e33c30' className='text-xl' />
                    </button>
                    <h2 className="mt-4 break-words   text-lg  xs:mt-8 xs:text-sm     sm:mt-8 sm:text-base   md:mt-4 md:text-base    smLaptop:mt-4 smLaptop:text-lg    lg:mt-4 lg:text-lg    xl:mt-4 xl:text-lg   font-bold  text-[#54709e]">
                        {modalQuestion}
                    </h2>
                    <div className='mt-8  text-lg    xs:mt-4 xs:text-xs     sm:mt-4 sm:text-sm   md:mt-4 md:text-sm    smLaptop:mt-4 smLaptop:text-base    lg:mt-4 lg:text-base    xl:mt-4 xl:text-base  float-right'>
                        <button onClick={onNoModalClick} className='bg-red-500 text-white mr-2 py-1 px-4  rounded'>No</button>
                        <button className='bg-blue-500 text-white py-1 px-3 rounded mr-2' onClick={onYesModalClick}>Yes</button>
                    </div>
            </Modal>
        </>
    )
}



export default MyModal;